module.exports = __webpack_public_path__ + "static/media/images@2x.e630f1d8.png";